import { LogicalOperator } from "./enums";
import type { IRuleConditionGroup, IRuleExclusions } from "./models/rule";

/** Default near-term window (days) used to compute "expiring soon" points. */
export const EXPIRING_SOON_WINDOW_DAYS = 60;

/** Page size options offered by rewards tables. */
export const REWARDS_PAGE_SIZES = [10, 20, 50, 100] as const;

/** Maximum supported nesting depth for rule condition groups. */
export const MAX_RULE_GROUP_DEPTH = 5;

/**
 * Upper bound of a rule action amount. The backend accepts `0 < amount ≤ 1,000,000`
 * for every action type (Ticketon.Rewards README §2, rule validation).
 */
export const MAX_RULE_ACTION_AMOUNT = 1_000_000;

/** Default empty exclusions block for a new rule. */
export function defaultExclusions(): IRuleExclusions {
  return {
    excludeRefunded: true,
    excludeWhenStackedWith: [],
    excludedSalesChannels: [],
  };
}

/**
 * Builds an empty root condition group. `idFactory` lets callers inject a
 * deterministic id generator (the core never calls Math.random / Date.now so
 * it stays pure and SSR-safe).
 */
export function emptyConditionGroup(idFactory: () => string): IRuleConditionGroup {
  return {
    id: idFactory(),
    operator: LogicalOperator.AND,
    conditions: [],
    groups: [],
  };
}
